import { useEffect, useState } from 'react';

export default function useTimer(durationInS: number) {
  const [timeLeft, setTimeLeft] = useState(durationInS);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    if (timeLeft === 0) {
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [timeLeft]);

  return { timeLeft, setTimeLeft };
}
